import React, {useCallback, useEffect, useMemo, useState} from "react";
import {Card, Col, Container, Row, Form, Button, Modal} from "react-bootstrap";
import {Link, useParams} from "react-router-dom";
import {useNavigate, useLocation} from "react-router-dom";
import TableContainer from "Common/TableContainer";
import 'react-toastify/dist/ReactToastify.css';
import {DeleteModal} from "Common/DeleteModal";
import {
    getAttributeSearch as onGetAttributeSearch,
    addAttributeList as onAddAttributeList,
    updateAttributeList as onUpdateAttributeList,
    deleteAttributeList as onDeleteAttributeList
} from "slices/attributes/thunk";
import {useDispatch, useSelector} from "react-redux";
import {ToastContainer} from "react-toastify";
import {useFormik} from "formik";
import * as Yup from "yup";

const useQuery = () => new URLSearchParams(useLocation().search);

const AttributesList = () => {
    document.title = "Attribute list";
    const dispatch = useDispatch<any>();
    const navigate = useNavigate();
    const query = useQuery();
    const location = useLocation();

    const pageParam = query.get("page");
    const pageFromUrl = pageParam ? parseInt(pageParam) : 1;
    const [pagination, setPagination] = useState<number>(pageFromUrl);
    const size = 10;

    const [listView, setListView] = useState<any>([]);
    const [attributeLists, setAttributeLists] = useState<any>(null);
    const [addAttribute, setAddAttribute] = useState<boolean>(false);
    const [editAttribute, setEditAttribute] = useState<boolean>(false);
    const [show, setShow] = useState<boolean>(false);
    const [search, setSearch] = useState<any>("");
    const [edit, setEdit] = useState<any>();
    const attributeList = useSelector((state: any) => state.Attribute.attributeList);

    useEffect(() => {
        const searchData = {page: pagination, size: size, search: search};
        dispatch(onGetAttributeSearch(searchData));
    }, [dispatch, search, pagination]);

    //add
    const handleCloseAttribute = () => {
        setAddAttribute(false);
    }
    const handleShowAttribute = () => setAddAttribute(true);
    //edit
    const handleEdit = useCallback((item: any) => {
        const lastItem = item.row.original
        setAddAttribute(true);
        setEditAttribute(true);
        setEdit({
            id: lastItem.id,
            attribute: lastItem.name,
        });
        console.log(lastItem)

    }, []);

    // delete
    const handleDeleteShow = (ele: any) => {
        setShow(true);
        setAttributeLists(ele);
    };

    const handleDeleteClose = () => {
        setShow(false);
    }

    //delete modal
    const deleteModalFunction = () => {
        const deleteData = attributeLists.row.original.id || {};
        console.log(deleteData);
        if (deleteData) {
            dispatch(onDeleteAttributeList(deleteData));
        }
        setShow(false);
    };

    useEffect(() => {
        setListView(attributeList.content);
    }, [attributeList]);

    //columns
    const columns = useMemo(
        () => [
            {
                header: (
                    <Form.Check>
                        <Form.Check.Input type="checkbox" value="option" id="checkAll"/>
                        <Form.Check.Label htmlFor="checkAll"></Form.Check.Label>
                    </Form.Check>
                ),
                cell: (cell: any) => {
                    return (
                        <Form.Check className="checkbox-product-list">
                            <Form.Check.Input type="checkbox" value="2" id="checkbox-2"/>
                            <Form.Check.Label htmlFor="checkbox-2"></Form.Check.Label>
                        </Form.Check>
                    );
                },
                id: "#",
                enableColumnFilter: false,
                enableSorting: false,
            },
            {
                header: "№",
                enableColumnFilter: false,
                enableSorting: false,
                cell: (cell: any) => {
                    return (
                        <span>{cell.row.index + 1}</span>
                    )
                }
            },
            {
                header: "Attribute name",
                accessorKey: "name",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Created At",
                accessorKey: "createdAt",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Updated At",
                accessorKey: "updatedAt",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Action",
                enableColumnFilter: false,
                enableSorting: false,
                cell: (cell: any) => {
                    return (
                        <ul className="d-flex gap-2 list-unstyled mb-0">
                            <li>
                                <Link to="#" className="btn btn-subtle-secondary btn-icon btn-sm edit-item-btn"
                                      onClick={() => handleEdit(cell)}><i className="ph-pencil"></i></Link>
                            </li>
                            <li className={"mx-2"}>
                                <Link to="#" className="btn btn-subtle-danger btn-icon btn-sm remove-item-btn"
                                      onClick={() => handleDeleteShow(cell)}><i className="ph-trash"></i></Link>
                            </li>
                        </ul>
                    );
                }
            },
        ], []
    );

    // validation
    const formik: any = useFormik({
        enableReinitialize: true,
        initialValues: {
            attribute: (edit && edit.attribute) || '',
            id: edit && edit.id,
        },
        validationSchema: Yup.object({
            attribute: Yup.string().required("Please Enter Your Attribute"),
        }),

        onSubmit: (values: any) => {

            if (editAttribute) {
                const data: any = {
                    name: values.attribute,
                    id: values.id
                }
                dispatch(onUpdateAttributeList(data));
                formik.resetForm();
            } else {
                const data: any = {
                    name: values.attribute
                }

                dispatch(onAddAttributeList(data));
                formik.resetForm();
            }
            if (values === null) {
                handleShowAttribute();
            } else {
                setEdit(null);
                setEditAttribute(false);
                handleCloseAttribute();
            }
        }
    });

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        params.set("page", pagination.toString());
        navigate({search: params.toString()}, {replace: true});
    }, [pagination, navigate, location.search]);

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>

                    <Row id="attributeList">
                        <Col lg={12}>
                            <Card>
                                <Card.Header>
                                    <Row className="align-items-center g-2">
                                        <Col lg={3} className="me-auto">
                                            <h6 className="card-title mb-0">Attribute List</h6>
                                        </Col>
                                        <Col xl={2} md={3}>
                                            <div className="search-box">
                                                <Form.Control
                                                    type="text" className="search"
                                                    placeholder="Search attribute..."
                                                    onChange={(e: any) => setSearch(e.target.value)}
                                                />
                                                <i className="ri-search-line search-icon"></i>
                                            </div>
                                        </Col>
                                        <Col className="col-md-auto">
                                            <div className="hstack gap-2">
                                                <Button className="btn btn-subtle-danger d-none" id="remove-actions">
                                                    <i className="ri-delete-bin-2-line"></i>
                                                </Button>
                                                <Button variant="secondary" onClick={handleShowAttribute}>
                                                    <i className="bi bi-plus-circle align-baseline me-1"></i> Add
                                                    Attribute
                                                </Button>
                                            </div>
                                        </Col>
                                    </Row>
                                </Card.Header>
                                <Card.Body className="mt-3">
                                    {
                                        listView && listView.length > 0 ?
                                            <TableContainer
                                                isPagination={true}
                                                columns={columns}
                                                data={listView || []}
                                                customPageSize={10}
                                                divClassName="table-responsive table-card"
                                                tableClass="table table-centered align-middle table-custom-effect table-nowrap mb-0"
                                                theadClass="table-light"
                                                PaginationClassName="align-items-center mt-4 pt-3"
                                                isBordered={false}
                                            />
                                            :
                                            <div id="noresult">
                                                <div className="text-center py-4">
                                                    <div className="avatar-md mx-auto mb-4">
                                                        <div
                                                            className="avatar-title bg-primary-subtle text-primary rounded-circle fs-5xl">
                                                            <i className="bi bi-search"></i>
                                                        </div>
                                                    </div>
                                                    <h5 className="mt-2">Sorry! No Result Found</h5>
                                                </div>
                                            </div>
                                    }
                                </Card.Body>
                            </Card>
                        </Col>

                    </Row>
                </Container>
            </div>
            <DeleteModal show={show} handleClose={handleDeleteClose} deleteModalFunction={deleteModalFunction}/>

            <Modal show={addAttribute} onHide={handleCloseAttribute}>
                <Modal.Header closeButton>
                    <Modal.Title>{editAttribute ? "update Attribute List" : "Add Attribute"}</Modal.Title>
                </Modal.Header>
                <Form autoComplete="off" onSubmit={formik.handleSubmit}>
                    <Modal.Body>
                        <div className="mb-3">
                            <Form.Label htmlFor="Customer-Name-input">Attribute Name<span
                                className="text-danger">*</span></Form.Label>
                            <Form.Control
                                type="text"
                                id="Customer-Name-input"
                                name="attribute"
                                placeholder="Attribute Name"
                                value={formik.values.attribute}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                isInvalid={!!formik.errors.attribute}
                            />
                            {formik.errors.attribute && formik.touched.attribute ? (
                                <Form.Control.Feedback type="invalid">{formik.errors.attribute}</Form.Control.Feedback>
                            ) : null}
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" className="btn btn-ghost-danger" onClick={handleCloseAttribute}>
                            <i className="bi bi-x-lg align-baseline me-1"></i> Close
                        </Button>
                        <Button type="submit" variant="primary"
                                id="add-btn">{editAttribute ? "update" : "Add Attribute"}</Button>
                    </Modal.Footer>
                </Form>
            </Modal>
            <ToastContainer/>
        </React.Fragment>
    );
};

export default AttributesList;